import LeadProfileView from './LeadProfileView';

export default LeadProfileView;
